import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  fr: {
    langLabel: "Français",
    nav: {
      services: "Services",
      why: "Pourquoi nous",
      quote: "Soumission",
      cta: "Soumission gratuite",
    },
    hero: {
      badge: "Professionnel. Fiable. Impeccable.",
      lines: ["Un entretien", "commercial"],
      lastText: "sur lequel ",
      lastAccent: "compter.",
      sub: "Un nettoyage fiable et professionnel pour les entreprises de toutes tailles — du petit bureau aux grands espaces commerciaux, partout à Montréal.",
      ctaQuote: "Obtenir une soumission gratuite",
      ctaServices: "Nos services",
      statLabel: "Axé sur la satisfaction",
    },
    marquee: ["Professionnel", "Fiable", "Impeccable", "OCD Entretien", "Commercial", "Désinfecté"],
    services: {
      eyebrow: "Ce que nous faisons",
      title: "Nos services",
      subtitle:
        "Une gamme complète de nettoyage commercial, adaptée au fonctionnement réel de votre espace.",
      items: [
        { title: "Nettoyage de bureaux", desc: "Des espaces de travail impeccables et professionnels." },
        { title: "Commerces & détail", desc: "Des espaces impeccables qui impressionnent vos clients." },
        { title: "Cliniques médicales", desc: "Désinfection de qualité hospitalière." },
        { title: "Entretien des planchers", desc: "Décapage, cirage et entretien." },
        { title: "Désinfection des toilettes", desc: "Désinfection en profondeur." },
        { title: "Époussetage & désinfection", desc: "Chaque surface, chaque détail." },
        { title: "Collecte des déchets", desc: "Ordures et recyclage, selon l'horaire." },
        { title: "Emménagement / Déménagement", desc: "Nettoyage complet de transition." },
        { title: "Forfaits personnalisés", desc: "Conçus selon votre budget." },
      ],
    },
    why: {
      eyebrow: "Pourquoi nous choisir",
      titleL1: "Une norme",
      titleL2: "que vous ",
      titleAccent: "voyez.",
      items: [
        { t: "Fiable & digne de confiance", d: "Nous sommes toujours au rendez-vous et traitons votre espace comme le nôtre." },
        { t: "Souci du détail", d: "Les recoins que d'autres oublient sont notre point de départ." },
        { t: "Horaire flexible", d: "Jour, soir ou fin de semaine — nous nous adaptons à vos opérations." },
        { t: "Prix compétitifs", d: "Des résultats haut de gamme, sans les tracas." },
        { t: "Satisfaction de la clientèle", d: "Un fini que vous pouvez voir, ressentir et en qui avoir confiance." },
        { t: "Professionnel & courtois", d: "Une équipe vérifiée et aimable que vous serez heureux d'accueillir." },
      ],
    },
    quote: {
      eyebrow: "Contactez-nous",
      titleL1: "Soumission",
      titleL2: "gratuite",
      sub: "Contactez-nous dès aujourd'hui pour une estimation gratuite et sans engagement. Décrivez-nous votre espace et nous bâtirons un plan selon votre budget.",
      nameLabel: "Nom complet",
      namePh: "Jeanne Tremblay",
      emailLabel: "Courriel",
      emailPh: "vous@entreprise.com",
      messageLabel: "Parlez-nous de votre espace",
      messagePh: "Superficie, fréquence, exigences particulières…",
      submit: "Obtenir ma soumission gratuite",
      sending: "Envoi…",
      successTitle: "Demande envoyée !",
      successDesc: "Merci — nous vous reviendrons sous peu avec votre soumission.",
      errorTitle: "Une erreur est survenue",
      errorDesc: "Veuillez réessayer ou nous appeler directement.",
    },
    roles: { ceo: "PDG" },
    footer: {
      services: "Services",
      why: "Pourquoi nous",
      quote: "Soumission",
      rights: "Tous droits réservés.",
      tagline: "Montréal · Nettoyage commercial",
    },
  },

  en: {
    langLabel: "English",
    nav: {
      services: "Services",
      why: "Why Us",
      quote: "Quote",
      cta: "Get a Quote",
    },
    hero: {
      badge: "Professional. Reliable. Spotless.",
      lines: ["Commercial", "cleaning your"],
      lastText: "business can ",
      lastAccent: "count on.",
      sub: "Reliable, professional cleaning for businesses of every size — from single offices to full commercial floors across Montréal.",
      ctaQuote: "Get a Free Quote",
      ctaServices: "Our Services",
      statLabel: "Satisfaction focused",
    },
    marquee: ["Professional", "Reliable", "Spotless", "OCD Entretien", "Commercial", "Sanitized"],
    services: {
      eyebrow: "What we do",
      title: "Our services",
      subtitle:
        "A full spectrum of commercial cleaning, tailored to the way your space actually operates.",
      items: [
        { title: "Office Cleaning", desc: "Pristine, professional workspaces that keep teams focused." },
        { title: "Retail & Commercial", desc: "Spotless spaces that impress every customer." },
        { title: "Medical Offices", desc: "Hospital-grade sanitization protocols." },
        { title: "Floor Care", desc: "Stripping, waxing & long-term maintenance." },
        { title: "Restroom Sanitization", desc: "Thorough, deep disinfection." },
        { title: "Dusting & Disinfecting", desc: "Every surface, every fine detail." },
        { title: "Waste Removal", desc: "Garbage & recycling, on schedule." },
        { title: "Move-In / Move-Out", desc: "Complete turnover cleaning." },
        { title: "Custom Plans", desc: "Built precisely around your budget." },
      ],
    },
    why: {
      eyebrow: "Why choose us",
      titleL1: "A standard",
      titleL2: "you can ",
      titleAccent: "see.",
      items: [
        { t: "Reliable & Trustworthy", d: "We show up, every time, and treat your space like our own." },
        { t: "Attention to Detail", d: "The corners others miss are where we begin." },
        { t: "Flexible Scheduling", d: "Day, night or weekend — we work around your operation." },
        { t: "Competitive Pricing", d: "Premium results without the premium runaround." },
        { t: "Customer Satisfaction", d: "A finish you can see, feel and trust." },
        { t: "Professional & Friendly", d: "A vetted, courteous team you'll be glad to have around." },
      ],
    },
    quote: {
      eyebrow: "Get in touch",
      titleL1: "Get a free",
      titleL2: "quote",
      sub: "Contact us today for a free, no-obligation estimate. Tell us about your space and we'll build a plan around your budget.",
      nameLabel: "Full name",
      namePh: "Jane Tremblay",
      emailLabel: "Email",
      emailPh: "you@company.com",
      messageLabel: "Tell us about your space",
      messagePh: "Office size, frequency, special requirements…",
      submit: "Request My Free Quote",
      sending: "Sending…",
      successTitle: "Request sent!",
      successDesc: "Thanks — we'll get back to you shortly with your quote.",
      errorTitle: "Something went wrong",
      errorDesc: "Please try again or call us directly.",
    },
    roles: { ceo: "CEO" },
    footer: {
      services: "Services",
      why: "Why Us",
      quote: "Get a Quote",
      rights: "All rights reserved.",
      tagline: "Montréal · Commercial Cleaning",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return window.localStorage.getItem("ocd_lang") || "fr";
    }
    return "fr";
  });

  useEffect(() => {
    window.localStorage.setItem("ocd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
